export var AlertThreshold;
(function (AlertThreshold) {
    AlertThreshold["Absolute"] = "absolute";
    AlertThreshold["Relative"] = "relative";
})(AlertThreshold || (AlertThreshold = {}));
export const AlertThresholdKey = {
    [AlertThreshold.Absolute]: 'MANUAL_ALERT_ABSOLUTE',
    [AlertThreshold.Relative]: 'MANUAL_ALERT_RELATIVE_THRESHOLD',
};
//# sourceMappingURL=alert.threshold.js.map